import { Feature } from '@tencent/workbench';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { AXIS_TYPE, IChartAxisTitleFeature, IChartAxisTitleShower } from '@tencent/chart-drawer-components/lib/interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { TITLE_MAX_CHAR_COUNT } from '../config';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { IAxisTitleProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/axis/axis-title.interface';
import { ChartElementType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';


@Feature({
    name: 'ChartAxisTitleFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IChartAxisTitleFeature,
})
export class ChartAxisTitleFeature extends ChartBaseDrawerFeature implements IChartAxisTitleFeature {
    private axisTitleProperty?: IAxisTitleProperty;

    public  setChartAxisTitleText(text: string, axisType?: AXIS_TYPE): void {
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.CHART) return;
        if (text.length > TITLE_MAX_CHAR_COUNT) return;
        const selectedElementType = model.selectedElement?.type;
        if (selectedElementType === ChartElementType.AXIS_TITLE) {
            this.axisTitleProperty = model.getSelectedElementProperty() as IAxisTitleProperty;
        }
        if (!this.axisTitleProperty) return;
        const axisTitle = this.axisTitleProperty;
        if (text === axisTitle?.getTitleText()) return;
        axisTitle?.updateTitleText(text);
    }
}

@Feature({
    name: 'ChartAxisTitleShower',
    adapters: [SLIDE_ADAPTER],
    provide: IChartAxisTitleShower,
})
export class ChartAxisTitleShower extends ChartBaseDrawerFeature implements IChartAxisTitleShower {
    public disableDebounce = true;
    public updateWhenBlur =  true;
    private axisTitleProperty?: IAxisTitleProperty;

    public getChartAxisTitleText(): string {
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.CHART) return '';
        const selectedElementType = model.selectedElement?.type;
        if (selectedElementType === ChartElementType.AXIS_TITLE) {
            this.axisTitleProperty = model.getSelectedElementProperty() as IAxisTitleProperty;
            if (!this.axisTitleProperty) return '';
            const title =  this.axisTitleProperty?.getTitleText() ?? '';
            return title;
        }
        return '';
    }
}
